import {useTranslation} from '@aboutyou/i18n';
import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {COLORS} from '../../../../constants/colors';
import {UnstyledButton} from '../../../atoms/Buttons/UnstyledButton';
import {Icon} from '../../../atoms/Icon/Icon';
import {GenericIconName} from '../../../atoms/Icon/IconName';
import {usePriceLegalInfoPopup} from './usePriceLegalInfoPopup';

export const LegalInfoButton: FC<{title: string; body: string}> = ({
  body,
  title,
}) => {
  const {t} = useTranslation();
  const {open} = usePriceLegalInfoPopup();

  const handleOnClick = () => {
    open({body, title});
  };

  return (
    <InfoButton onClick={handleOnClick} aria-label={t('Open RRP info window')}>
      <StyledIcon
        asset={GenericIconName.InfoSquaredGray}
        fill={COLORS.strikePriceGrey}
      />
    </InfoButton>
  );
};

const InfoButton = styled(UnstyledButton)`
  margin-top: -2px;
`;

const StyledIcon = styled(Icon)`
  --icon-size: 16px;

  width: var(--icon-size);
  height: var(--icon-size);
  flex-basis: var(--icon-size);
`;
